'use strict';

var react = require('@emotion/react');

const qualityBadge = /*#__PURE__*/ react.css({
    height: "24px",
    width: "24px"
}, "label:label-QualityBadge-web-stylesqualityBadge", "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL2J1aWxkcy9kZXZlbG9wZXJzL2F2aWFyeS9wYWNrYWdlcy9hdmlhcnktd2ViL3NyYy9jb21wb25lbnRzL3BsYXRmb3JtL1F1YWxpdHlCYWRnZS9RdWFsaXR5QmFkZ2Uud2ViLnN0eWxlcy50cyIsInNvdXJjZXMiOlsiL2J1aWxkcy9kZXZlbG9wZXJzL2F2aWFyeS9wYWNrYWdlcy9hdmlhcnktd2ViL3NyYy9jb21wb25lbnRzL3BsYXRmb3JtL1F1YWxpdHlCYWRnZS9RdWFsaXR5QmFkZ2Uud2ViLnN0eWxlcy50cyJdLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBjc3MgfSBmcm9tIFwiQGVtb3Rpb24vcmVhY3RcIjtcblxuZXhwb3J0IGNvbnN0IHF1YWxpdHlCYWRnZSA9IGNzcyh7XG4gIGhlaWdodDogXCIyNHB4XCIsXG4gIHdpZHRoOiBcIjI0cHhcIixcbn0pO1xuIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUU0QiJ9 */");

exports.qualityBadge = qualityBadge;
//# sourceMappingURL=QualityBadge.web.styles.cjs.map
